import { Injectable } from '@angular/core';
import { HttpClient, HttpParams } from '@angular/common/http';
import { Observable, Subject, from } from 'rxjs';
import { map, catchError, finalize } from 'rxjs/operators';
import { environment } from '../../../environments/environment';
import { ConfigurationManagerService } from './configuration-manager.service';


@Injectable({
  providedIn: 'root'
})
export class PapiService {

  private api: any = {};
  private paginateLimit = 10000;
  private errorCount = 0;
  private http: HttpClient;
  private requests: { [key: string]: Subject<void> } = {};

  constructor(
    private httpClient: HttpClient,

  ) {
    this.http = httpClient;
    this.initializeApi();
  }

  private initializeApi(): void {
    const baseUrl = ConfigurationManagerService.settings.BaseURL;
    const user = sessionStorage.getItem('user') || localStorage.getItem('user');

    this.api = {
     // authenticate: new PatrociniumApi.AuthenticateApi(this.http, baseUrl),
     // db: new PatrociniumApi.DbApi(this.http, baseUrl)
    };

    Object.keys(this.api).forEach(client => {
      this.api[client].requests = {};
      this.api[client].timeouts = {};

      if (client !== 'authenticate' && user) {
        this.api[client].defaultHeaders = {
        //  Authorization: user.token
        };
      }
    });
  }

  private serializeParams(params: any): string {
    if (!params) return '';
    
    const parts: string[] = [];
    this.serialize(params, '', true, parts);
    return parts.join('&');
  }

  private serialize(toSerialize: any, prefix: string, topLevel: boolean, parts: string[]): void {
    if (toSerialize === undefined) return;

    if (Array.isArray(toSerialize)) {
      toSerialize.forEach((value, index) => {
        this.serialize(value, `${prefix}[${typeof value === 'object' ? index : ''}]`, false, parts);
      });
    } else if (typeof toSerialize === 'object' && !(toSerialize instanceof Date)) {
      Object.keys(toSerialize)
        .sort()
        .forEach(key => {
          this.serialize(
            toSerialize[key],
            `${prefix}${topLevel ? '' : '['}${key}${topLevel ? '' : ']'}`,
            false,
            parts
          );
        });
    } else if (toSerialize === null) {
      parts.push(this.encodeUriQuery(prefix));
    } else {
      parts.push(
        `${this.encodeUriQuery(prefix)}=${this.encodeUriQuery(this.serializeValue(toSerialize))}`
      );
    }
  }

  private encodeUriQuery(val: string, pctEncodeSpaces = false): string {
    return encodeURIComponent(val)
      .replace(/%40/gi, '@')
      .replace(/%3A/gi, ':')
      .replace(/%24/g, '$')
      .replace(/%2C/gi, ',')
      .replace(/%3B/gi, ';')
      .replace(/%20/g, pctEncodeSpaces ? '%20' : '+');
  }

  private serializeValue(v: any): string {
    if (typeof v === 'object') {
      return v instanceof Date ? v.toISOString() : JSON.stringify(v);
    }
    return v;
  }

  // request<T>(
  //   id: string,
  //   client: string,
  //   method: string,
  //   parameters: any = {},
  //   options: { paginate?: boolean } = {}
  // ) {
  //   const apiClient = this.api[client];
  //   options = { paginate: false, ...options };

  //   if (options.paginate) {
  //     const methodDependencies = this.getMethodDependencies(apiClient[method]);
  //     parameters = parameters || {};
      
  //     if (methodDependencies.includes('body')) {
  //       parameters.body = parameters.body || {};
  //       parameters.body.limit = parameters.body.limit || this.paginateLimit;
  //     } else if (methodDependencies.includes('limit')) {
  //       parameters.limit = parameters.limit || this.paginateLimit;
  //     }
  //   }
  //   return this.create<T>(id, client, method, parameters).pipe(
  //     map(response => {
  //       this.errorCount = 0;
  //       return options.paginate ? this.paginate(id, client, method, parameters, response) : response;
  //     })
  //   );
  // }

  request<T>(
  id: string,
  client: string,
  method: string,
  parameters: any = {},
  options: { paginate?: boolean } = {}
) {
  const apiClient = this.api[client];
  if (!apiClient) {
    throw new Error(`Patrocinium API client (${client}) does not exist. Check initialization.`);
  }
  if (typeof apiClient[method] !== 'function') {
    throw new Error(`Patrocinium API client (${client}) method (${method}) is not callable. Does it exist?`);
  }

  options = { paginate: false, ...options };

  if (options.paginate) {
    const methodDependencies = this.getMethodDependencies(apiClient[method]);
    parameters = parameters || {};

    if (methodDependencies.includes('body')) {
      parameters.body = parameters.body || {};
      parameters.body.limit = parameters.body.limit || this.paginateLimit;
    } else if (methodDependencies.includes('limit')) {
      parameters.limit = parameters.limit || this.paginateLimit;
    }
  }

  return this.create<T>(id, client, method, parameters).pipe(
    map(response => {
      this.errorCount = 0;
      return options.paginate
        ? this.paginate(id, client, method, parameters, response)
        : response;
    })
  );
}


  private paginate<T>(
    id: string,
    client: string,
    method: string,
    parameters: any,
    response: any
  ) {
    const apiClient = this.api[client];
    const methodDependencies = this.getMethodDependencies(apiClient[method]);
    const limit = parameters.limit || this.paginateLimit;
    const inBody = methodDependencies.includes('body');

    if (!response.data?.count || !response.data?.rows || inBody === undefined) {
      return from([response]);
    }

    const count = Number(response.data.count);
    const rowsLength = Number(response.data.rows.length);

    if (rowsLength >= count) {
      return from([response]);
    }

    const taskCount = Math.ceil((count - rowsLength) / limit);
    const tasks = [];

    for (let i = 1; i <= taskCount; i++) {
      const pageId = `${id}-page-${i}`;
      const offset = rowsLength + (limit * (i - 1));
      const pageParameters = {
        ...parameters,
        ...(inBody ? { body: { offset, limit } } : { offset, limit })
      };

      tasks.push(this.create(pageId, client, method, pageParameters));
    }

    return from(tasks).pipe(
      map(results => {
       // const byId = results.data.rows?.[0]?.id;
        results.forEach(result => {
         // if (byId) {
           // response.data.rows = [...new Map([...response.data.rows, ...result.data.rows].map(item => [item.id, item])).values()];
         // } else {
           // response.data.rows = [...response.data.rows, ...result.data.rows];
         // }
        });
        return response;
      })
    );
  }

  private create<T>(
    id: string,
    client: string,
    method: string,
    parameters: any
  ): Observable<T> {
    const apiClient = this.api[client];
    const methodDependencies = this.getMethodDependencies(apiClient[method]);
    const methodArguments = new Array(methodDependencies.length).fill(undefined);

    if (apiClient.requests[id]) {
      apiClient.requests[id].next();
    }

    const cancel$ = new Subject<void>();
    apiClient.requests[id] = cancel$;

    parameters = {
      ...parameters,
      extraHttpRequestParams: {
        timeout: cancel$.asObservable()
      }
    };

    Object.entries(parameters).forEach(([name, value]) => {
      const methodArgumentKey = methodDependencies.indexOf(name);
      if (methodArgumentKey !== -1) {
        methodArguments[methodArgumentKey] = value;
      } else {
        console.error(`Parameter (${name}) is not a dependency of the Patrocinium API method (${method})`);
      }
    });

    return apiClient[method](...methodArguments).pipe(
      map(response => {
        apiClient.unauthCount = 0;
        return response;
      }),
      catchError(response => {
        if (apiClient.unauthCount++ > 5 && response.status === 403) {
          this.handleUnauthorized();
        }
        throw response;
      }),
      finalize(() => {
        delete apiClient.requests[id];
      })
    );
  }


  

  private getMethodDependencies(method: Function): string[] {
    // This is a placeholder - in Angular 18, we'd typically use decorators or metadata
    // to track method dependencies. You'll need to implement this based on your specific needs.
    return [];
  }

  private handleUnauthorized(): void {
    sessionStorage.removeItem('user');
    localStorage.removeItem('user');
    localStorage.removeItem('PAA_AUTH_TOKEN');
    localStorage.removeItem('PAA_COGNITO_TOKEN');
    window.location.href = '/login';
  }
}
